module.exports = __webpack_public_path__ + "static/img/dyhlogo.a1d960e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dyhlogo.png
// module id = mH1S
// module chunks = 4